export const HEIGHTS = {
  xsmall: 275,
  default: 420,
  medium: 700,
  large: 900,
} as const;

export type ImageCarouselHeight = keyof typeof HEIGHTS;

export function isImageCarouselHeight(
  value: unknown,
): value is ImageCarouselHeight {
  return typeof value === 'string' && value in HEIGHTS;
}
